const isPricing = process.env.IS_PRICING == 1 ? true : false;

export const SHOW_BUILDER_FEED_URL_LINK = true;

export const configVarSubsPage = {
    SUBS_PAGE_NAME: isPricing ? 'pricing' : 'payments', //can use for type, page, route
    SUBS_PAGE_TITLE: isPricing ? 'Pricing Page' : 'Marketers Page',
    SUBS_PAGE_ROUTE: isPricing ? 'pricing' : 'marketers',
}


//{key:"payments", id:"payments", title:"Marketers Page", type:"payments", page:"marketers", route:"marketers"})
// {key: "pricing",id: "pricing",title: "Pricing Page",type: "pricing",page: "pricing",route:"pricing"}
// {key:configVarSubsPage.SUBS_PAGE_NAME, id:configVarSubsPage.SUBS_PAGE_NAME, name:configVarSubsPage.SUBS_PAGE_TITLE, type:configVarSubsPage.SUBS_PAGE_NAME, page:configVarSubsPage.SUBS_PAGE_ROUTE, route:configVarSubsPage.SUBS_PAGE_ROUTE}